<asw-payment-input-pres
  [isReadyToShow]="isReadyToShow"
  [screenEntry]="screenEntry"
  [pnrInfo]="pnrInfo"
  [phoneCountryInfoList]="phoneCountryInfoList"
  [isDisplayPaymentMethodSelection]="isDisplayPaymentMethodSelection"
  [paymentMethod]="paymentMethod"
  [currentOfficeInfo]="currentOfficeInfo"
  [isChangePaymentMethod]="isChangePaymentMethod"
  [isChangeCreditCard]="isChangeCreditCard"
  [isCreditCardPayment]="isCreditCardPayment"
  [isAfterStartingFrom]="isAfterStartingFrom"
  (getMemberInformation)="getMemberInformation()"
  (getAvailabilityPaymentMethod)="getAvailabilityPaymentMethod()"
  [(data)]="data"
  [parts]="parts"
  [prevScreenInfo]="prevScreenInfo"
  [isDisplayPayMethodSelectionArea]="isDisplayPayMethodSelectionArea"
  (dataChange)="dataUpdateEvent(data)"
  (displayScreenInformation)="displayScreenInformation()"
  [isReservationOnly]="screenEntry.isReservationOnly"
  [isShowShareholderCouponsArea]="screenEntry.isShowShareholderCouponsArea"
  [shareholderCoupons]="screenEntry.shareholderCoupons"
  [isWaitlisted]="screenEntry.isWaitlisted"
  [isContainedShareholdersBenefitDiscountFareByPostCollection]="
    this.pnrInfo?.air?.isContainedShareholdersBenefitDiscountFareByPostCollection ?? true
  "
  [isContainedShareholdersBenefitDiscountFare]="this.pnrInfo?.air?.isContainedShareholdersBenefitDiscountFare ?? false"
></asw-payment-input-pres>
